// Operations exposed by the API on a path (the path capabilities say which ones are possible).
export type PathFragmentOperationKey =
    "ReadEnabled" |
    "AddEnabled" |
    "AddMultipleEnabled" |
    "UpdateEnabled" |
    "UpdateMultipleEnabled" |
    "DeleteEnabled" |
    "DeleteMultipleEnabled";

export const PathFragmentOperationKeys: PathFragmentOperationKey[] = [
    "ReadEnabled",
    "AddEnabled",
    "AddMultipleEnabled",
    "UpdateEnabled",
    "UpdateMultipleEnabled",
    "DeleteEnabled",
    "DeleteMultipleEnabled"
];

export type PathFragmentOperations = Record<PathFragmentOperationKey, boolean>;

export default class PathFragmentDto implements PathFragmentOperations {

    PathFragmentId: number;
    MethodName: string;
    PathId: number;
    PathName: string;

    ReadEnabled: boolean;
    AddEnabled: boolean;
    AddMultipleEnabled: boolean;
    UpdateEnabled: boolean;
    UpdateMultipleEnabled: boolean;
    DeleteEnabled: boolean;
    DeleteMultipleEnabled: boolean;

    constructor(pathFragmentId: number, methodName: string, pathId: number, pathName: string, operations: PathFragmentOperations) {
        this.PathFragmentId = pathFragmentId;
        this.MethodName = methodName;
        this.PathId = pathId;
        this.PathName = pathName;

        this.ReadEnabled = operations.ReadEnabled;
        this.AddEnabled = operations.AddEnabled;
        this.AddMultipleEnabled = operations.AddMultipleEnabled;
        this.UpdateEnabled = operations.UpdateEnabled;
        this.UpdateMultipleEnabled = operations.UpdateMultipleEnabled;
        this.DeleteEnabled = operations.DeleteEnabled;
        this.DeleteMultipleEnabled = operations.DeleteMultipleEnabled;
    }
}
